export const getEventPoint = (clientX: number, clientY: number, svg: SVGSVGElement) => {
    const point = svg.createSVGPoint()

    point.x = clientX
    point.y = clientY

    return point
}

export const getRelativeMousePoint = (clientX: number, clientY: number, svg: SVGSVGElement) => {
    const inversedScreenCTM = svg.getScreenCTM()?.inverse()
    return getEventPoint(clientX, clientY, svg).matrixTransform(
        inversedScreenCTM
    )
}
